import { useListConnections } from '@/api/generated/integrations.ts';
import { useWorkspace } from '@/api/workspaces.ts';

// A member who can't connect anything has nothing to see there until the owner connects something. A client's
// employee has no workspace settings, so their connections aren't asked for.
const useHasConnectionsTab = () => {
    const workspace = useWorkspace();
    const connections = useListConnections({ query: { enabled: workspace.role !== 'employee' } });
    const workspaceConnections = (connections.data ?? []).filter((connection) => !connection.is_own);
    return workspace.permissions.can_connect_integrations || workspaceConnections.length > 0;
};

export default useHasConnectionsTab;
